/** @jsx jsx */
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { css, jsx } from '@emotion/core';
// import Score from './Scoring/Score';

const findUl = node => {
  if (node === document.body) {
    return;
  }

  if (node.parentNode.tagName.toLowerCase() === 'ul') {
    // foundUl = true;
    // console.log(node.parentNode);
    return node.parentNode;
  }

  return findUl(node.parentNode);
};

const Indent = ({ type, attributes, children }) => {
  const indent: any = useRef(null);

  useLayoutEffect(() => {
    const foundUl = findUl(indent.current.parentNode);
    // console.log({ foundUl });

    let closestLi;
    if (foundUl) {
      closestLi = indent.current.closest('li');
      if (closestLi) {
        closestLi.classList.add('indent');
      }
    } else {
      indent.current.classList.add('indent-alt');
    }

    return () => {
      closestLi?.classList.remove('indent');
      indent.current.classList.remove('indent-alt');
    };
  }, []);

  useEffect(() => {
    // indent.current.classList.add('indent-alt');

    requestAnimationFrame(() => {
      const foundUl = findUl(indent.current.parentNode);

      if (!foundUl && indent.current.classList.contains('indent-alt')) {
        console.log('kill it with fire !!!');
      }
    });
  }, []);

  return (
    <span ref={indent} data-type={type} {...attributes}>
      {children}
    </span>
  );
};

const renderMark = (props, editor, next) => {
  const { children, mark, attributes } = props;
  const { type, data } = mark;

  switch (type) {
    case 'bold':
      return <strong {...attributes}>{children}</strong>;
    case 'italic':
      return <em {...attributes}>{children}</em>;
    case 'underline':
      return <u {...attributes}>{children}</u>;

    case 'fontFamily':
      const fontFamily = data.get('fontFamily');

      return (
        <span style={{ fontFamily }} data-type={type} {...attributes}>
          {/* <link
            href={`https://fonts.googleapis.com/css?family=${fontFamily}:300,400`}
            rel="stylesheet"
          /> */}
          {children}
        </span>
      );

    case 'fontSize':
      return (
        <span
          style={{ fontSize: parseInt(data.get('fontSize'), 10) }}
          data-type={type}
          {...attributes}
        >
          {children}
        </span>
      );

    case 'color':
      return (
        <span
          style={{ color: data.get('color') }}
          data-type={type}
          {...attributes}
        >
          {children}
        </span>
      );

    case 'indent': {
      return (
        <Indent type={type} attributes={attributes}>
          {children}
        </Indent>
      );
    }

    case 'superscript': {
      return (
        <sup data-type={type} {...attributes}>
          {children}
        </sup>
      );
    }

    case 'subscript': {
      return (
        <sub data-type={type} {...attributes}>
          {children}
        </sub>
      );
    }

    // case 'score': {
    //   return <Score {...{ editor, ...attributes }}>{children}</Score>;
    // }

    default:
      return next();
  }
};

export default renderMark;
